/*
  Reels Video Player (shared)
  ---------------------------------------------------------------------------
  Fullscreen, Instagram/Reels-style vertical video lightbox. Loaded (deferred)
  by snippets/reels-video-player.liquid; see that file for usage.

  The styles live in this file and are injected the first time the player is
  built, so pages pay nothing for them until a shopper actually opens a video.
*/
(function () {
  'use strict';
  if (window.ReelsVideoPlayer) return;

  var STYLES = `
.rvp-lightbox {
  position: fixed;
  inset: 0;
  z-index: 2147483647;
  display: none;
  background: rgba(0, 0, 0, 0.96);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  opacity: 0;
  transition: opacity 0.3s ease;
  --rvp-reviews-btn-bg: #ffffff;
  --rvp-reviews-btn-color: #111111;
  --rvp-accent: #e5ff42;
}
.rvp-lightbox.is-open { display: block; opacity: 1; }

.rvp-shell {
  position: absolute;
  inset: 0;
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  grid-template-areas: "side-left viewport side-right";
  align-items: center;
  gap: 24px;
  padding: 24px;
  transition: grid-template-columns 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}
.rvp-lightbox.reviews-open .rvp-shell { grid-template-columns: 1fr auto 460px; }

.rvp-side {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  overflow: hidden;
  pointer-events: auto;
  transition: opacity 0.3s ease;
}
.rvp-side[data-side="left"]  { grid-area: side-left;  justify-content: flex-end; }
.rvp-side[data-side="right"] { grid-area: side-right; justify-content: flex-start; }
.rvp-lightbox.reviews-open .rvp-side[data-side="left"] { opacity: 0.3; pointer-events: none; }

.rvp-side-thumb {
  width: 88px;
  aspect-ratio: 9 / 16;
  border-radius: 10px;
  overflow: hidden;
  cursor: pointer;
  background-size: cover;
  background-position: center;
  box-shadow: 0 8px 22px rgba(0, 0, 0, 0.4);
  transition: transform 0.3s ease, opacity 0.3s ease;
  flex-shrink: 0;
  border: none;
  padding: 0;
}
.rvp-side[data-side="left"] .rvp-side-thumb  { transform: perspective(800px) rotateY(15deg); opacity: 0.7; }
.rvp-side[data-side="right"] .rvp-side-thumb { transform: perspective(800px) rotateY(-15deg); opacity: 0.7; }
.rvp-side-thumb:hover { opacity: 1 !important; transform: perspective(800px) rotateY(0deg) scale(1.04) !important; }

.rvp-side-arrow {
  width: 44px; height: 44px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: #fff;
  display: flex; align-items: center; justify-content: center;
  cursor: pointer;
  transition: background 0.2s ease, transform 0.2s ease;
  flex-shrink: 0;
}
.rvp-side-arrow:hover { background: rgba(255, 255, 255, 0.22); transform: scale(1.06); }
.rvp-side-arrow svg { width: 24px; height: 24px; }

.rvp-viewport {
  grid-area: viewport;
  position: relative;
  width: min(420px, 86vw, calc(92vh * 9 / 16));
  aspect-ratio: 9 / 16;
  background: #000;
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 30px 80px rgba(0, 0, 0, 0.55);
  user-select: none;
  -webkit-touch-callout: none;
  touch-action: pan-y;
  transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.rvp-stack {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  transform: translateY(0);
  will-change: transform;
  transition: transform 0.35s cubic-bezier(0.32, 0.72, 0, 1);
}
.rvp-stack.is-dragging { transition: none !important; }

.rvp-slide { position: relative; width: 100%; height: 100%; flex-shrink: 0; }

.rvp-cover, .rvp-video {
  position: absolute; inset: 0;
  width: 100%; height: 100%;
  object-fit: cover;
}
.rvp-cover { background-size: cover; background-position: center; z-index: 1; transition: opacity 0.4s ease; }
.rvp-video { z-index: 2; background: #000; }

.rvp-progress {
  position: absolute; left: 12px; right: 12px; top: 12px;
  height: 3px;
  background: rgba(255, 255, 255, 0.22);
  border-radius: 999px;
  overflow: hidden;
  z-index: 5;
}
.rvp-progress__bar { height: 100%; width: 0%; background: rgba(255, 255, 255, 0.95); transition: width 0.1s linear; }

.rvp-controls { position: absolute; top: 18px; right: 12px; display: flex; gap: 8px; z-index: 6; }
.rvp-ctrl-btn {
  width: 36px; height: 36px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.42);
  border: 1px solid rgba(255, 255, 255, 0.16);
  color: #fff;
  display: grid; place-items: center;
  cursor: pointer;
  font-size: 13px; font-weight: 700;
  -webkit-tap-highlight-color: transparent;
  transition: background 0.2s ease;
}
.rvp-ctrl-btn:hover { background: rgba(0, 0, 0, 0.7); }
.rvp-ctrl-btn svg { width: 20px; height: 20px; display: block; }
.rvp-ctrl-btn--speed[data-speed="2x"] { background: rgba(255, 255, 255, 0.22); }

.rvp-center-play {
  position: absolute; inset: 0;
  display: none; align-items: center; justify-content: center;
  z-index: 7; pointer-events: none;
}
.rvp-center-play.is-visible { display: flex; }
.rvp-center-play__btn {
  width: 64px; height: 64px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.45);
  border: none; color: #fff;
  display: grid; place-items: center;
  pointer-events: auto; cursor: pointer;
}
.rvp-center-play__btn svg { width: 34px; height: 34px; margin-left: 3px; fill: #fff; }

.rvp-reviews-btn {
  position: absolute; left: 50%; bottom: 16px;
  transform: translateX(-50%);
  z-index: 8;
  display: inline-flex; align-items: center; gap: 8px;
  padding: 11px 22px;
  border: none; border-radius: 999px;
  background: var(--rvp-reviews-btn-bg, #fff);
  color: var(--rvp-reviews-btn-color, #1a1a1a);
  font-size: 14px; font-weight: 700; letter-spacing: 0.2px;
  cursor: pointer;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.32);
  -webkit-tap-highlight-color: transparent;
  transition: transform 0.2s ease, box-shadow 0.2s ease, opacity 0.3s ease;
}
/* The display above would otherwise beat the hidden attribute, and the button
   would show for openers that pass no reviews. */
.rvp-reviews-btn[hidden] { display: none; }
.rvp-reviews-btn:hover { transform: translateX(-50%) scale(1.04); box-shadow: 0 10px 26px rgba(0, 0, 0, 0.4); }
.rvp-reviews-btn:active { transform: translateX(-50%) scale(0.98); }
.rvp-reviews-btn svg { width: 18px; height: 18px; }
.rvp-lightbox.reviews-open .rvp-reviews-btn { opacity: 0; pointer-events: none; }

.rvp-reviews-panel {
  position: fixed; z-index: 10;
  background: #fff; color: #1a1a1a;
  display: flex; flex-direction: column;
  box-shadow: 0 -8px 30px rgba(0, 0, 0, 0.25), 0 0 30px rgba(0, 0, 0, 0.15);
  transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  top: 24px; right: 24px; bottom: 24px;
  width: 440px; max-width: calc(100vw - 48px);
  border-radius: 16px;
  transform: translateX(calc(100% + 32px));
  pointer-events: none;
}
.rvp-lightbox.reviews-open .rvp-reviews-panel { transform: translateX(0); pointer-events: auto; }

.rvp-reviews-panel__header {
  display: flex; align-items: center; justify-content: space-between; gap: 12px;
  padding: 18px 20px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  flex-shrink: 0;
}
.rvp-reviews-panel__title { margin: 0; font-size: 17px; font-weight: 700; line-height: 1.3; }
.rvp-reviews-panel__close {
  width: 36px; height: 36px;
  border: none; border-radius: 50%;
  background: rgba(0, 0, 0, 0.06); color: #1a1a1a;
  display: grid; place-items: center;
  cursor: pointer; transition: background 0.2s ease; flex-shrink: 0;
}
.rvp-reviews-panel__close:hover { background: rgba(0, 0, 0, 0.12); }
.rvp-reviews-panel__close svg { width: 22px; height: 22px; }

.rvp-reviews-panel__body {
  flex: 1 1 auto;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding: 16px 20px 24px;
}
.rvp-reviews-panel__body .jdgm-widget { font-size: 14px; }
.rvp-reviews-panel__loading {
  display: flex; align-items: center; justify-content: center; gap: 10px;
  padding: 24px 0; color: rgba(0, 0, 0, 0.5); font-size: 13px;
}
.rvp-reviews-panel__loading::before {
  content: "";
  width: 16px; height: 16px;
  border-radius: 50%;
  border: 2px solid rgba(0, 0, 0, 0.12);
  border-top-color: rgba(0, 0, 0, 0.5);
  animation: rvp-spin 0.8s linear infinite;
}
@keyframes rvp-spin { to { transform: rotate(360deg); } }

.rvp-reviews-panel__handle {
  display: none;
  width: 40px; height: 4px;
  margin: 8px auto 0;
  border-radius: 999px;
  background: rgba(0, 0, 0, 0.18);
  flex-shrink: 0;
}

@media (max-width: 767px) {
  .rvp-shell {
    grid-template-columns: 1fr;
    grid-template-areas: "viewport";
    padding: 0; gap: 0;
    height: 100vh; height: 100dvh;
  }
  .rvp-lightbox.reviews-open .rvp-shell { grid-template-columns: 1fr; }
  .rvp-side { display: none; }

  .rvp-viewport {
    width: 100vw; height: 100vh; height: 100dvh;
    aspect-ratio: auto; border-radius: 0; max-width: none;
    transform-origin: top center;
  }
  .rvp-lightbox.reviews-open .rvp-viewport { transform: scale(0.4) translateY(0); border-radius: 14px; }

  .rvp-reviews-panel {
    top: auto; right: 0; bottom: 0; left: 0;
    width: 100%; max-width: 100%;
    height: 58vh; max-height: 58dvh;
    border-radius: 18px 18px 0 0;
    transform: translateY(100%);
    touch-action: pan-y;
  }
  .rvp-lightbox.reviews-open .rvp-reviews-panel { transform: translateY(0); }
  .rvp-reviews-panel__handle { display: block; }
  .rvp-reviews-panel__header { padding: 12px 18px 14px; }

  .rvp-progress { top: 14px; left: 14px; right: 14px; }
  .rvp-controls { top: 22px; right: 14px; }
  .rvp-ctrl-btn { width: 40px; height: 40px; }
  .rvp-reviews-btn { bottom: calc(20px + env(safe-area-inset-bottom, 0px)); padding: 12px 24px; font-size: 15px; }
}

@media (max-width: 1100px) {
  .rvp-side .rvp-side-thumb:not(:first-child):not(:last-child) { display: none; }
}
@media (max-width: 900px) and (min-width: 768px) {
  .rvp-side-thumb { width: 70px; }
}

/* Judge.me photo/media modals must sit above the lightbox */
[class*="jdgm-modal"],
[class*="jdgm-medias-popup"],
[class*="jdgm-photo-modal"],
[class*="jdgm-pop-up"],
.jdgm-rev__pic-overlay,
.jdgm-modal-bg { z-index: 2147483647 !important; }

@media (prefers-reduced-motion: reduce) {
  .rvp-lightbox, .rvp-shell, .rvp-stack, .rvp-viewport,
  .rvp-reviews-panel, .rvp-reviews-btn, .rvp-side, .rvp-side-thumb,
  .rvp-side-arrow, .rvp-progress__bar { transition: none !important; animation: none !important; }
}
`;

  function injectStyles() {
    if (document.querySelector('style[data-rvp-styles]')) return;
    var style = document.createElement('style');
    style.setAttribute('data-rvp-styles', '');
    style.textContent = STYLES;
    document.head.appendChild(style);
  }

  /* ─── Inline icons ─── */
  var ICONS = {
    close:    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>',
    volumeUp: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 15V9h4l5-4v14l-5-4H3z"/><path d="M16 8.5a4 4 0 010 7M18.5 6a7.5 7.5 0 010 12"/></svg>',
    volumeOff:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 15V9h4l5-4v14l-5-4H3z"/><path d="M16 9l5 6M21 9l-5 6"/></svg>',
    play:     '<svg viewBox="0 0 24 24"><path d="M8 5v14l11-7z"/></svg>',
    chevronL: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M15.4 7.4 14 6l-6 6 6 6 1.4-1.4L10.8 12z"/></svg>',
    chevronR: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M10 6 8.6 7.4 13.2 12l-4.6 4.6L10 18l6-6z"/></svg>',
    reviews:  '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2l2.9 6.3 6.9.6-5.2 4.6 1.6 6.7L12 17.3 5.8 20.8l1.6-6.7L2.2 8.9l6.9-.6z"/></svg>'
  };

  function escAttr(s) { return String(s == null ? '' : s).replace(/'/g, '&#39;').replace(/"/g, '&quot;'); }

  var lb = null;
  var lbState = { videos: [], activeIndex: 0, isMuted: false, isPaused: false, reviewsOpen: false, speed: 1, opts: {} };
  var lbActiveVideo = null;
  var lbReviewsHydrated = false;
  var bodyOverflowSnapshot = '';

  function buildLightbox() {
    if (lb) return lb;
    injectStyles();
    var el = document.createElement('div');
    el.className = 'rvp-lightbox';
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-hidden', 'true');
    el.innerHTML =
      '<div class="rvp-shell" data-rvp-shell>' +
        '<nav class="rvp-side" data-side="left" aria-label="Previous videos"></nav>' +
        '<div class="rvp-viewport" data-rvp-viewport>' +
          '<div class="rvp-progress" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="0">' +
            '<div class="rvp-progress__bar" data-rvp-progress></div>' +
          '</div>' +
          '<div class="rvp-controls">' +
            '<button type="button" class="rvp-ctrl-btn rvp-ctrl-btn--speed" data-rvp-speed aria-label="Toggle speed">1x</button>' +
            '<button type="button" class="rvp-ctrl-btn" data-rvp-mute aria-label="Toggle sound">' + ICONS.volumeUp + '</button>' +
            '<button type="button" class="rvp-ctrl-btn" data-rvp-close aria-label="Close">' + ICONS.close + '</button>' +
          '</div>' +
          '<div class="rvp-center-play" data-rvp-center-play>' +
            '<button type="button" class="rvp-center-play__btn" data-rvp-resume aria-label="Resume">' + ICONS.play + '</button>' +
          '</div>' +
          '<div class="rvp-stack" data-rvp-stack></div>' +
          '<button type="button" class="rvp-reviews-btn" data-rvp-reviews-open hidden>' +
            ICONS.reviews + '<span data-rvp-reviews-btn-text>Reviews</span>' +
          '</button>' +
        '</div>' +
        '<nav class="rvp-side" data-side="right" aria-label="Next videos"></nav>' +
      '</div>' +
      '<aside class="rvp-reviews-panel" data-rvp-reviews-panel aria-hidden="true">' +
        '<div class="rvp-reviews-panel__handle" data-rvp-reviews-handle></div>' +
        '<header class="rvp-reviews-panel__header">' +
          '<h3 class="rvp-reviews-panel__title" data-rvp-reviews-title>Reviews</h3>' +
          '<button type="button" class="rvp-reviews-panel__close" data-rvp-reviews-close aria-label="Close reviews">' + ICONS.close + '</button>' +
        '</header>' +
        '<div class="rvp-reviews-panel__body" data-rvp-reviews-body>' +
          '<div class="rvp-reviews-panel__loading" data-rvp-reviews-loading><span>Loading</span></div>' +
        '</div>' +
      '</aside>';
    document.body.appendChild(el);

    lb = {
      el: el,
      shell:        el.querySelector('[data-rvp-shell]'),
      viewport:     el.querySelector('[data-rvp-viewport]'),
      stack:        el.querySelector('[data-rvp-stack]'),
      progress:     el.querySelector('[data-rvp-progress]'),
      sideLeft:     el.querySelector('[data-side="left"]'),
      sideRight:    el.querySelector('[data-side="right"]'),
      btnSpeed:     el.querySelector('[data-rvp-speed]'),
      btnMute:      el.querySelector('[data-rvp-mute]'),
      btnClose:     el.querySelector('[data-rvp-close]'),
      centerPlay:   el.querySelector('[data-rvp-center-play]'),
      btnResume:    el.querySelector('[data-rvp-resume]'),
      btnReviews:   el.querySelector('[data-rvp-reviews-open]'),
      btnReviewsLabel: el.querySelector('[data-rvp-reviews-btn-text]'),
      reviewsPanel: el.querySelector('[data-rvp-reviews-panel]'),
      reviewsTitle: el.querySelector('[data-rvp-reviews-title]'),
      reviewsBody:  el.querySelector('[data-rvp-reviews-body]'),
      reviewsLoading: el.querySelector('[data-rvp-reviews-loading]'),
      reviewsClose: el.querySelector('[data-rvp-reviews-close]'),
      reviewsHandle: el.querySelector('[data-rvp-reviews-handle]')
    };

    attachHandlers();
    return lb;
  }

  function renderStack() {
    lb.stack.innerHTML = lbState.videos.map(function (v, i) {
      var coverStyle = v.coverUrl ? 'background-image:url(\'' + escAttr(v.coverUrl) + '\')' : '';
      return '<section class="rvp-slide" data-rvp-slide data-index="' + i + '">' +
        '<div class="rvp-cover" style="' + coverStyle + '"></div>' +
        '<video class="rvp-video" data-rvp-video data-src="' + escAttr(v.videoUrl) + '" playsinline preload="none"></video>' +
      '</section>';
    }).join('');
  }

  function renderSideThumbs() {
    if (!lb.sideLeft || !lb.sideRight) return;
    var n = lbState.activeIndex;
    var total = lbState.videos.length;
    var lefts = [], rights = [];
    for (var i = 1; i <= 2; i++) { if (n - i >= 0) lefts.unshift(n - i); }
    for (var j = 1; j <= 2; j++) { if (n + j < total) rights.push(n + j); }

    var leftHtml = lefts.map(function (idx) {
      var u = lbState.videos[idx].coverUrl || '';
      return '<button type="button" class="rvp-side-thumb" data-rvp-thumb data-index="' + idx + '" style="background-image:url(\'' + escAttr(u) + '\')" aria-label="Video ' + (idx + 1) + '"></button>';
    }).join('');
    leftHtml += '<button type="button" class="rvp-side-arrow" data-rvp-nav="prev" aria-label="Previous">' + ICONS.chevronL + '</button>';

    var rightHtml = '<button type="button" class="rvp-side-arrow" data-rvp-nav="next" aria-label="Next">' + ICONS.chevronR + '</button>';
    rightHtml += rights.map(function (idx) {
      var u = lbState.videos[idx].coverUrl || '';
      return '<button type="button" class="rvp-side-thumb" data-rvp-thumb data-index="' + idx + '" style="background-image:url(\'' + escAttr(u) + '\')" aria-label="Video ' + (idx + 1) + '"></button>';
    }).join('');

    lb.sideLeft.innerHTML = leftHtml;
    lb.sideRight.innerHTML = rightHtml;
  }

  function positionStack(animate) {
    if (!lb || !lb.viewport || !lb.stack) return;
    var h = lb.viewport.offsetHeight;
    var y = -(lbState.activeIndex * h);
    lb.stack.style.transition = animate ? '' : 'none';
    lb.stack.style.transform = 'translateY(' + y + 'px)';
    if (!animate) {
      lb.stack.offsetHeight; /* reflow */
      lb.stack.style.transition = '';
    }
  }

  function syncActiveVideo() {
    var slides = lb.stack.querySelectorAll('[data-rvp-slide]');
    slides.forEach(function (slide) {
      var idx = parseInt(slide.dataset.index, 10);
      var vid = slide.querySelector('[data-rvp-video]');
      if (!vid) return;
      if (idx === lbState.activeIndex) {
        loadVideo(vid);
        vid.muted = lbState.isMuted;
        vid.playbackRate = lbState.speed || 1;
        if (lbState.isPaused) { try { vid.pause(); } catch (e) {} }
        else { var p = vid.play(); if (p && p.catch) p.catch(function () {}); }
        attachVideoProgress(vid);
        lbActiveVideo = vid;
      } else {
        try { vid.pause(); vid.currentTime = 0; } catch (e) {}
      }
    });

    /* Preload the previous/next clip for smoother swiping. With large files this
       doubles/triples the data used, so it's gated by opts.preloadAdjacent:
         'off'     -> never preload neighbours (only the active clip downloads)
         'desktop' -> preload only on desktop, poster-only wait on mobile (default)
         'always'  -> always preload neighbours */
    if (shouldPreloadAdjacent()) {
      [lbState.activeIndex - 1, lbState.activeIndex + 1].forEach(function (i) {
        if (i < 0 || i >= lbState.videos.length) return;
        var s = lb.stack.querySelector('[data-rvp-slide][data-index="' + i + '"]');
        if (s) loadVideo(s.querySelector('[data-rvp-video]'));
      });
    }
  }

  function shouldPreloadAdjacent() {
    var mode = (lbState.opts && lbState.opts.preloadAdjacent) || 'desktop';
    if (mode === 'off') return false;
    if (mode === 'always') return true;
    /* 'desktop' (default): skip neighbour preloading on small screens to save data */
    return !(window.matchMedia && window.matchMedia('(max-width: 749px)').matches);
  }

  function loadVideo(vid) {
    if (!vid || vid.dataset.loaded || !vid.dataset.src) return;
    var source = document.createElement('source');
    source.src = vid.dataset.src;
    source.type = 'video/mp4';
    vid.appendChild(source);
    vid.dataset.loaded = '1';
    try { vid.load(); } catch (e) {}
  }

  function attachVideoProgress(vid) {
    if (vid._rvpBound) return;
    vid._rvpBound = true;
    vid.addEventListener('timeupdate', function () {
      if (vid !== lbActiveVideo || !vid.duration || isNaN(vid.duration)) return;
      lb.progress.style.width = (vid.currentTime / vid.duration * 100) + '%';
    });
    vid.addEventListener('ended', function () {
      vid.currentTime = 0;
      var p = vid.play(); if (p && p.catch) p.catch(function () {});
    });
  }

  function setActiveSlide(index, opts) {
    opts = opts || {};
    var total = lbState.videos.length;
    lbState.activeIndex = Math.max(0, Math.min(total - 1, index));
    lbState.isPaused = false;
    lbState.speed = 1;
    if (lb.btnSpeed) { lb.btnSpeed.textContent = '1x'; lb.btnSpeed.dataset.speed = '1x'; }
    if (lb.progress) lb.progress.style.width = '0%';
    positionStack(opts.animate !== false);
    renderSideThumbs();
    syncActiveVideo();
    updateCenterPlay();
  }

  function updateCenterPlay() {
    if (!lb || !lb.centerPlay) return;
    lb.centerPlay.classList.toggle('is-visible', lbState.isPaused);
  }

  function updateMuteIcon() {
    if (!lb || !lb.btnMute) return;
    lb.btnMute.innerHTML = lbState.isMuted ? ICONS.volumeOff : ICONS.volumeUp;
  }

  /* ─── Judge.me hydration ─── */
  function hydrateJudgeMe(widgetEl, productId) {
    if (!widgetEl) return;
    try { widgetEl.removeAttribute('data-auto-install'); } catch (e) {}

    var hidLoading = false;
    function hideLoading() {
      if (hidLoading) return;
      hidLoading = true;
      if (lb.reviewsLoading) lb.reviewsLoading.style.display = 'none';
    }

    var initialHTML = widgetEl.innerHTML.trim();
    if (initialHTML.length > 50) {
      hideLoading();
    } else if (typeof MutationObserver !== 'undefined') {
      var observer = new MutationObserver(function () {
        var html = widgetEl.innerHTML.trim();
        if (html.length > 200 || widgetEl.children.length >= 2) {
          observer.disconnect();
          hideLoading();
        }
      });
      observer.observe(widgetEl, { childList: true, subtree: true });
      setTimeout(function () { try { observer.disconnect(); } catch (e) {} hideLoading(); }, 8000);
    } else {
      setTimeout(hideLoading, 3000);
    }

    function callInit() {
      var jd = window.jdgm;
      if (!jd) return;
      try { if (typeof jd.update === 'function') jd.update(); } catch (e) {}
      try { if (jd._reviewWidget && typeof jd._reviewWidget.draw === 'function') jd._reviewWidget.draw(productId); } catch (e) {}
      try {
        if (jd.JdgmReviewWidget && typeof jd.JdgmReviewWidget === 'function' && !widgetEl._jdgmInited) {
          new jd.JdgmReviewWidget(widgetEl);
          widgetEl._jdgmInited = true;
        }
      } catch (e) {}
      try { document.dispatchEvent(new CustomEvent('jdgm:installed:review-widget', { detail: { id: productId } })); } catch (e) {}
    }

    callInit();
    var retries = 0;
    var retryTimer = setInterval(function () {
      retries++;
      if (hidLoading || retries >= 20) { clearInterval(retryTimer); return; }
      callInit();
    }, 250);
  }

  function openReviewsPanel() {
    if (!lb || lbState.reviewsOpen) return;
    if (!lbReviewsHydrated) {
      var source = lbState.opts.reviewsSource || null;
      if (typeof source === 'string') source = document.querySelector(source);
      if (source) {
        var inner = source.classList && source.classList.contains('rvp-reviews-inner')
          ? source
          : source.querySelector('.rvp-reviews-inner') || source;
        lb.reviewsBody.appendChild(inner);
        requestAnimationFrame(function () {
          var widgetEl = inner.querySelector('.jdgm-review-widget');
          var productId = widgetEl && widgetEl.getAttribute('data-product-id');
          hydrateJudgeMe(widgetEl, productId);
        });
        if (source.parentNode && source !== inner) { try { source.parentNode.removeChild(source); } catch (e) {} }
      } else if (lb.reviewsLoading) {
        lb.reviewsLoading.textContent = 'No product configured for reviews.';
      }
      lbReviewsHydrated = true;
    }
    lbState.reviewsOpen = true;
    lb.el.classList.add('reviews-open');
    lb.reviewsPanel.setAttribute('aria-hidden', 'false');
  }

  function closeReviewsPanel() {
    if (!lb || !lbState.reviewsOpen) return;
    lbState.reviewsOpen = false;
    lb.el.classList.remove('reviews-open');
    lb.reviewsPanel.setAttribute('aria-hidden', 'true');
  }

  /* ─── Drag / swipe ─── */
  function attachDragHandlers() {
    var startY = 0, currentY = 0, baseOffset = 0, dragging = false, wasDrag = false;
    var THRESHOLD = 50;
    function getH() { return lb.viewport.offsetHeight; }
    function setY(y, animate) {
      lb.stack.style.transition = animate ? '' : 'none';
      lb.stack.style.transform = 'translateY(' + y + 'px)';
      lb.stack.classList.toggle('is-dragging', !animate);
    }
    function onStart(clientY, target) {
      if (target && target.closest('[data-rvp-mute],[data-rvp-close],[data-rvp-speed],[data-rvp-resume],[data-rvp-reviews-open]')) return false;
      if (lbState.reviewsOpen) return false;
      dragging = true; wasDrag = false;
      startY = clientY; currentY = clientY;
      baseOffset = -(lbState.activeIndex * getH());
      setY(baseOffset, false);
      return true;
    }
    function onMove(clientY) {
      if (!dragging) return;
      currentY = clientY;
      var delta = currentY - startY;
      if (Math.abs(delta) > 8) wasDrag = true;
      setY(baseOffset + delta, false);
    }
    function onEnd() {
      if (!dragging) return;
      dragging = false;
      var delta = currentY - startY;
      var n = lbState.activeIndex;
      var total = lbState.videos.length;
      if (Math.abs(delta) > THRESHOLD) {
        if (delta < 0 && n < total - 1) n++;
        else if (delta > 0 && n > 0) n--;
      }
      setActiveSlide(n);
      setTimeout(function () { wasDrag = false; }, 50);
    }

    lb.viewport.addEventListener('touchstart', function (e) { if (e.touches.length === 1) onStart(e.touches[0].clientY, e.target); }, { passive: true });
    lb.viewport.addEventListener('touchmove', function (e) { if (dragging) { e.preventDefault(); onMove(e.touches[0].clientY); } }, { passive: false });
    lb.viewport.addEventListener('touchend', onEnd);
    lb.viewport.addEventListener('touchcancel', function () { dragging = false; });

    lb.viewport.addEventListener('mousedown', function (e) { if (e.button === 0 && onStart(e.clientY, e.target)) e.preventDefault(); });
    document.addEventListener('mousemove', function (e) { if (dragging) { e.preventDefault(); onMove(e.clientY); } });
    document.addEventListener('mouseup', function () { if (dragging) onEnd(); });

    lb.viewport.addEventListener('click', function (e) {
      if (wasDrag) { wasDrag = false; return; }
      if (e.target.closest('[data-rvp-mute],[data-rvp-close],[data-rvp-speed],[data-rvp-resume],[data-rvp-reviews-open],[data-rvp-thumb],[data-rvp-nav]')) return;
      lbState.isPaused = !lbState.isPaused;
      if (lbActiveVideo) {
        if (lbState.isPaused) { try { lbActiveVideo.pause(); } catch (er) {} }
        else { var p = lbActiveVideo.play(); if (p && p.catch) p.catch(function () {}); }
      }
      updateCenterPlay();
    });

    /* Mobile: swipe down panel to close */
    var pStartY = 0, pCurY = 0, pDrag = false;
    function pStart(y) { if (!lbState.reviewsOpen) return; pDrag = true; pStartY = y; pCurY = y; lb.reviewsPanel.style.transition = 'none'; }
    function pMove(y) { if (!pDrag) return; pCurY = y; lb.reviewsPanel.style.transform = 'translateY(' + Math.max(0, pCurY - pStartY) + 'px)'; }
    function pEnd() {
      if (!pDrag) return;
      pDrag = false;
      var delta = pCurY - pStartY;
      lb.reviewsPanel.style.transition = '';
      lb.reviewsPanel.style.transform = '';
      if (delta > 80) closeReviewsPanel();
    }
    [lb.reviewsHandle, lb.reviewsPanel.querySelector('.rvp-reviews-panel__header')].forEach(function (zone) {
      if (!zone) return;
      zone.addEventListener('touchstart', function (e) { if (e.touches.length === 1) pStart(e.touches[0].clientY); }, { passive: true });
      zone.addEventListener('touchmove', function (e) { if (pDrag) pMove(e.touches[0].clientY); }, { passive: true });
      zone.addEventListener('touchend', pEnd);
      zone.addEventListener('touchcancel', function () { pDrag = false; });
    });
  }

  function attachHandlers() {
    lb.btnClose.addEventListener('click', closeLightbox);
    lb.el.addEventListener('click', function (e) { if (e.target === lb.el) closeLightbox(); });

    lb.btnResume.addEventListener('click', function (e) {
      e.stopPropagation();
      lbState.isPaused = false;
      if (lbActiveVideo) { var p = lbActiveVideo.play(); if (p && p.catch) p.catch(function () {}); }
      updateCenterPlay();
    });

    lb.btnMute.addEventListener('click', function (e) {
      e.stopPropagation();
      lbState.isMuted = !lbState.isMuted;
      if (lbActiveVideo) lbActiveVideo.muted = lbState.isMuted;
      updateMuteIcon();
    });

    lb.btnSpeed.addEventListener('click', function (e) {
      e.stopPropagation();
      lbState.speed = lbState.speed === 1 ? 2 : 1;
      if (lbActiveVideo) lbActiveVideo.playbackRate = lbState.speed;
      lb.btnSpeed.textContent = lbState.speed + 'x';
      lb.btnSpeed.dataset.speed = lbState.speed + 'x';
    });

    lb.btnReviews.addEventListener('click', function (e) { e.stopPropagation(); openReviewsPanel(); });
    lb.reviewsClose.addEventListener('click', closeReviewsPanel);

    function navHandler(e) {
      var thumb = e.target.closest('[data-rvp-thumb]');
      if (thumb) { setActiveSlide(parseInt(thumb.dataset.index, 10)); return; }
      var arrow = e.target.closest('[data-rvp-nav]');
      if (arrow) {
        var dir = arrow.dataset.rvpNav;
        var n = lbState.activeIndex;
        var total = lbState.videos.length;
        if (dir === 'prev' && n > 0) n--;
        else if (dir === 'next' && n < total - 1) n++;
        setActiveSlide(n);
      }
    }
    lb.sideLeft.addEventListener('click', navHandler);
    lb.sideRight.addEventListener('click', navHandler);

    document.addEventListener('keydown', function (e) {
      if (!lb.el.classList.contains('is-open')) return;
      if (e.key === 'Escape') { if (lbState.reviewsOpen) closeReviewsPanel(); else closeLightbox(); }
      else if (e.key === 'ArrowDown' && !lbState.reviewsOpen) { e.preventDefault(); if (lbState.activeIndex < lbState.videos.length - 1) setActiveSlide(lbState.activeIndex + 1); }
      else if (e.key === 'ArrowUp' && !lbState.reviewsOpen) { e.preventDefault(); if (lbState.activeIndex > 0) setActiveSlide(lbState.activeIndex - 1); }
    });

    window.addEventListener('resize', function () { positionStack(false); });

    attachDragHandlers();
  }

  /* ─── Judge.me overlay tracking ─── */
  var jdgmModalObserver = null, jdgmTrackedModals = null;
  var JDGM_MODAL_REGEX = /jdgm-(modal|medias-popup|pop-up|photo-modal|rev-widg__modal|rev__pic-overlay|pic-modal)/;
  function isJdgmModal(node) {
    if (!node || node.nodeType !== 1) return false;
    var cn = node.className;
    return typeof cn === 'string' && cn && JDGM_MODAL_REGEX.test(cn);
  }
  function hoistJdgmModal(node) {
    try {
      node.style.setProperty('z-index', '2147483647', 'important');
      if (node.parentNode === document.body && node !== document.body.lastElementChild) document.body.appendChild(node);
      jdgmTrackedModals && jdgmTrackedModals.add(node);
    } catch (e) {}
  }
  function startWatchingJdgmModals() {
    if (jdgmModalObserver || typeof MutationObserver === 'undefined') return;
    jdgmTrackedModals = new Set();
    document.querySelectorAll('[class*="jdgm-modal"],[class*="jdgm-medias-popup"],[class*="jdgm-pop-up"]').forEach(function (n) { if (isJdgmModal(n)) hoistJdgmModal(n); });
    jdgmModalObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) { m.addedNodes.forEach(function (node) { if (isJdgmModal(node)) hoistJdgmModal(node); }); });
    });
    jdgmModalObserver.observe(document.body, { childList: true });
  }
  function stopWatchingJdgmModals() {
    if (jdgmModalObserver) { try { jdgmModalObserver.disconnect(); } catch (e) {} jdgmModalObserver = null; }
  }
  function cleanupJudgeMeOverlays() {
    var closeSelectors = ['.jdgm-modal__close-button', '.jdgm-modal__close', '.jdgm-medias-popup__close-button', '.jdgm-medias-popup__close', '.jdgm-pop-up__close', '[class*="jdgm"][class*="close-button"]'].join(',');
    document.querySelectorAll(closeSelectors).forEach(function (btn) {
      try {
        var r = btn.getBoundingClientRect();
        if (r.width > 0 && r.height > 0 && getComputedStyle(btn).visibility !== 'hidden') btn.click();
      } catch (e) {}
    });
    if (jdgmTrackedModals) {
      jdgmTrackedModals.forEach(function (m) {
        try {
          if (m && m.parentNode) {
            m.style.setProperty('display', 'none', 'important');
            m.classList.remove('jdgm-modal--open', 'jdgm-pop-up--open', 'jdgm-medias-popup--open');
          }
        } catch (e) {}
      });
      jdgmTrackedModals.clear();
    }
    setTimeout(function () {
      ['jdgm-modal-open', 'jdgm-pop-up-open', 'jdgm-no-scroll', 'jdgm-overlay-open'].forEach(function (c) {
        try { document.body.classList.remove(c); } catch (e) {}
        try { document.documentElement.classList.remove(c); } catch (e) {}
      });
      if (!document.body.classList.contains('rvp-active')) {
        document.body.style.overflow = bodyOverflowSnapshot || '';
        document.documentElement.style.overflow = '';
      }
    }, 100);
  }

  function openLightbox(videos, startIndex, opts) {
    if (!videos || !videos.length) return;
    buildLightbox();
    opts = opts || {};

    lbState.videos = videos;
    lbState.activeIndex = startIndex || 0;
    lbState.isMuted = false;
    lbState.isPaused = false;
    lbState.reviewsOpen = false;
    lbState.speed = 1;
    lbState.opts = opts;

    /* Theme accent + reviews button colors */
    if (opts.accent) lb.el.style.setProperty('--rvp-accent', opts.accent);
    if (opts.reviewsButtonBg) lb.el.style.setProperty('--rvp-reviews-btn-bg', opts.reviewsButtonBg);
    if (opts.reviewsButtonColor) lb.el.style.setProperty('--rvp-reviews-btn-color', opts.reviewsButtonColor);

    /* Reviews button visibility */
    var hasReviews = !!opts.reviewsSource || lbReviewsHydrated;
    if (typeof opts.reviewsSource === 'string') hasReviews = !!document.querySelector(opts.reviewsSource) || lbReviewsHydrated;
    if (hasReviews) {
      if (opts.reviewsButtonText && lb.btnReviewsLabel) lb.btnReviewsLabel.textContent = opts.reviewsButtonText;
      if (opts.reviewsTitle && lb.reviewsTitle) lb.reviewsTitle.textContent = opts.reviewsTitle;
      lb.btnReviews.hidden = false;
    } else {
      lb.btnReviews.hidden = true;
    }

    renderStack();
    renderSideThumbs();
    updateMuteIcon();
    updateCenterPlay();
    lb.btnSpeed.textContent = '1x'; lb.btnSpeed.dataset.speed = '1x';
    lb.progress.style.width = '0%';

    lb.el.classList.add('is-open');
    lb.el.setAttribute('aria-hidden', 'false');
    document.body.classList.add('rvp-active');
    bodyOverflowSnapshot = document.body.style.overflow || '';
    document.body.style.overflow = 'hidden';

    try { document.dispatchEvent(new CustomEvent('rvp:open')); } catch (e) {}

    startWatchingJdgmModals();

    requestAnimationFrame(function () { positionStack(false); syncActiveVideo(); });
  }

  function closeLightbox() {
    if (!lb) return;
    cleanupJudgeMeOverlays();
    stopWatchingJdgmModals();
    var vids = lb.stack.querySelectorAll('[data-rvp-video]');
    vids.forEach(function (v) { try { v.pause(); } catch (e) {} });
    lbActiveVideo = null;
    if (lbState.reviewsOpen) closeReviewsPanel();
    lb.el.classList.remove('is-open');
    lb.el.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('rvp-active');
    document.body.style.overflow = bodyOverflowSnapshot || '';
    document.documentElement.style.overflow = '';

    try { document.dispatchEvent(new CustomEvent('rvp:close')); } catch (e) {}
  }

  window.ReelsVideoPlayer = { open: openLightbox, close: closeLightbox };

  /* Lets an opener that was clicked before this file arrived finish its open. */
  try { document.dispatchEvent(new CustomEvent('rvp:ready')); } catch (e) {}
})();
